<div class="modal-header" hsDraggable="modal-dialog">
  <h4 class="modal-title">Available Hotkeys</h4>
  <button
    nf-icon-button="secondary"
    icon="close"
    class="btn-bare"
    ngbTooltip="Close"
    (click)="activeModal.dismiss()"
  >
    Close
  </button>
</div>
<div class="modal-body" hsDraggable="modal-dialog">
  <nf-search [formControl]="search" class="mb-3"></nf-search>
  <div class="hotkey-descriptions pr-2">
    <div
      *ngIf="(activeHotkeys | async)?.length === 0"
      class="hotkey justify-content-center pt-4"
    >
      <h3 class="m-0">No Hotkeys match the current search.</h3>
    </div>
    <div
      *ngFor="let hotkey of activeHotkeys | async; let lastHotkey = last"
      class="hotkey"
      [ngClass]="{ 'disabled-hotkey': !hotkey.bound }"
    >
      <div class="pr-2">
        <div
          *ngIf="!hotkey.bound"
          class="badge badge-secondary"
          container="body"
          ngbTooltip="The panel that uses this hotkey has not been added to the layout."
        >
          DISABLED
        </div>
        <div class="badge badge-secondary" container="body">
          {{ hotkey.options?.scope ?? 'Global' }}
        </div>
        <div>{{ hotkey.name }}</div>
        <div class="small text-muted">
          {{ hotkey.description }}
        </div>
      </div>
      <div
        class="key-combo d-flex flex-column align-items-end justify-content-starts"
      >
        <div
          *ngFor="let combo of hotkey.keyCombos; let lastCombo = last"
          [ngClass]="{ 'pb-1': !lastCombo }"
        >
          <ng-template ngFor let-key [ngForOf]="combo" let-lastKey="last">
            <span class="badge badge-secondary">
              {{ key }}
            </span>
            <small *ngIf="!lastKey" class="px-1">+</small>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer" hsDraggable="modal-dialog">
  <button nf-button="cancel" (click)="activeModal.dismiss()"></button>
</div>
